module.exports = __webpack_public_path__ + "media/radiance2.bd5433f1.webm";